import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { take } from 'rxjs/operators';
import { GmsapidataService } from 'src/app/core/services/gmsapidata.service';


@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(private snackBar: MatSnackBar, private gmsApiService: GmsapidataService) { }

  snackMsg(message, duration = 3000) { // default duration is 3 sec
    this.snackBar.open(message, 'x', { "duration": duration });
  }

  public multimediaAPI(reqObj, callBack) {
    this.gmsApiService.multimediaUpload(reqObj).pipe(take(1)).subscribe((response: any) => {
      if (response) callBack(response);
    });
  }

  uniqueId = () => {
    return new Date().getTime();
  };
  resetFileUploadVal(id) {
    const input = document.querySelector(id) as HTMLInputElement | null;
    input.value = "";
  }

  multimediaResponse(data, response) {
    let imgNames = [];
    for (let i = 0; i < response.length; i++) {
      if (!response[i].status) {
        imgNames.push(data[i].image_path.substring(data[i].image_path.lastIndexOf('_') + 1));
      }
    }
    if (imgNames.length > 0) {
      let msg = "Error while uploading these images";
      this.snackMsg(msg + " : " + imgNames.join(), 7000);
    }
  }
  getDifferenceInMinutes(data) {
    return Number((data) / (1000 * 60)).toFixed(2);
  }
  getDifferenceInDays(data) {
    return Number((data) / (60 * 24)).toFixed(2);
  }
  checkStartEndDateValidation(isStatusActive, start_date, end_date, callBack) {
    let d1 = new Date(); //getting current date and time
    let d2 = new Date(d1.getUTCFullYear(), d1.getUTCMonth(), d1.getUTCDate(), d1.getUTCHours(), d1.getUTCMinutes(), d1.getUTCSeconds()); //current date and time in UTC
    let finalData: any = {
      "status": true,
      "msg": ''
    }
    if (!isStatusActive) {
      let diff1 = d2.getTime() - new Date(start_date).getTime();
      console.log(diff1);
      if (diff1 > 60 * 1000) { //60*1000 = 1min(60000 millisec)
        finalData.status = false;
        finalData.msg = 'Start Time must be greater than Current time';
        callBack(finalData);
      }
      //if(d2.getTime() >  new Date(end_date).getTime()) {
      let diff2 = d2.getTime() - new Date(end_date).getTime();
      console.log(diff2);
      if (diff2 > 60 * 1000) {
        finalData.status = false;
        finalData.msg = 'End Time must be greater than Current time';
        callBack(finalData);
      }
      if (new Date(start_date).getTime() > new Date(end_date).getTime()) {
        finalData.status = false;
        finalData.msg = 'End Time must be greater than Start time';
        callBack(finalData);
      } else {
        callBack(finalData);
      }
    } else {
      let diff2 = d2.getTime() - new Date(end_date).getTime();
      console.log(diff2);
      if (diff2 > 60 * 1000) {
        finalData.status = false;
        finalData.msg = 'End Time must be greater than Current time';
        callBack(finalData);
      } else {
        callBack(finalData);
      }
    }
  }

  formatImg(data) {
    var str = data.replaceAll("&lt;", "<");
    var txt = str.replaceAll("&gt;", ">&nbsp;");
    var finalStr = txt.replaceAll("<img", '<img width="28" height="28" class="smiley-codes"');
    return finalStr;
  }

  hexToEmoji(message) {
    const hexRegex = /&amp;#x([0-9A-Fa-f]{1,5});/g;
    if (hexRegex.test(message)) {
      return message.replace(hexRegex, (match, hex) => {
        return String.fromCodePoint(parseInt(hex, 16));
      });
    }
    return message;
  }

  getDecimalNumToFixed(num,fixedTo) {
    if ((num - Math.floor(num)) !== 0){
      return Number(num.toFixed(fixedTo));
    } else {
      return num;
    }
  }

}
